module.exports = __webpack_public_path__ + "img/Icon_FreeSnacks.21578f76.png";